import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, ViewChild } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';

import { AsyncPipe } from '@angular/common';
import { HmfSnackbarComponent } from '@dsg-tech/homefield-angular';
import { ProductListSnackbarService } from '@plp/data-access/services';

@Component({
    selector: 'plp-components-product-list-snackbar',
    imports: [HmfSnackbarComponent, AsyncPipe],
    template: `
		<hmf-snackbar #snackbar
			class="hmf-position-fixed plp-snackbar"
			[action]="'auto-dismiss'"
			[linkType]="'event'"
			[type]="'error'"
			>
			<span class="hmf-body-l">{{ snackbarMessage$ | async }}</span>
		</hmf-snackbar>
	`,
    styleUrl: './product-list-snackbar.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductListSnackbarComponent implements OnDestroy {
	@ViewChild('snackbar') hmfSnackbar: HmfSnackbarComponent;
	private readonly destroy$ = new Subject<void>();

	readonly snackbarMessage$ = this.snackbarService.snackbar$.pipe(takeUntil(this.destroy$));

	constructor(
		private readonly snackbarService: ProductListSnackbarService,
		private readonly cdr: ChangeDetectorRef
	) {
		this.snackbarMessage$.subscribe((msg: string) => {
			if (msg) {
				this.triggerSnackbar();
			} else {
				this.closeSnackbar();
			}
		});
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}

	triggerSnackbar(): void {
		if (this.hmfSnackbar) {
			this.hmfSnackbar.openSnackbar();
			setTimeout(() => {
				this.closeSnackbar();
			}, this.hmfSnackbar.dismissDelay * 1000);
		}
	}

	closeSnackbar(): void {
		if (this.hmfSnackbar) {
			this.hmfSnackbar.closeSnackbar();
			this.cdr.detectChanges();
		}
	}
}
